var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTarget(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.5,
    height: 15.5,
    viewBox: "0 0 15.5 15.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "target",
    d: "M4.375-9.344A4.6,4.6,0,0,1,7.75-10.75a4.577,4.577,0,0,1,3.359,1.391A4.577,4.577,0,0,1,12.5-6a4.577,4.577,0,0,1-1.391,3.359A4.577,4.577,0,0,1,7.75-1.25,4.577,4.577,0,0,1,4.391-2.641,4.577,4.577,0,0,1,3-6,4.552,4.552,0,0,1,4.375-9.344ZM5.438-3.687A3.21,3.21,0,0,0,7.75-2.75a3.131,3.131,0,0,0,2.3-.953A3.131,3.131,0,0,0,11-6a3.131,3.131,0,0,0-.953-2.3,3.131,3.131,0,0,0-2.3-.953,3.131,3.131,0,0,0-2.3.953A3.131,3.131,0,0,0,4.5-6,3.21,3.21,0,0,0,5.438-3.687ZM2.25-11.469a7.5,7.5,0,0,1,5.5-2.281,7.47,7.47,0,0,1,5.484,2.266A7.47,7.47,0,0,1,15.5-6,7.47,7.47,0,0,1,13.234-.516,7.47,7.47,0,0,1,7.75,1.75,7.47,7.47,0,0,1,2.266-.516,7.47,7.47,0,0,1,0-6,7.445,7.445,0,0,1,2.25-11.469ZM3.313-1.562A6.1,6.1,0,0,0,7.75.25a6.024,6.024,0,0,0,4.422-1.828A6.024,6.024,0,0,0,14-6a6.024,6.024,0,0,0-1.828-4.422A6.024,6.024,0,0,0,7.75-12.25a6.024,6.024,0,0,0-4.422,1.828A6.024,6.024,0,0,0,1.5-6,6.1,6.1,0,0,0,3.313-1.562ZM6.5-7.219A1.71,1.71,0,0,1,7.75-7.75a1.684,1.684,0,0,1,1.234.516A1.684,1.684,0,0,1,9.5-6a1.684,1.684,0,0,1-.516,1.234A1.684,1.684,0,0,1,7.75-4.25a1.684,1.684,0,0,1-1.234-.516A1.684,1.684,0,0,1,6-6,1.658,1.658,0,0,1,6.5-7.219Z",
    transform: "translate(0 13.75)",
    fill: "#0a0a0a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTarget);
export default __webpack_public_path__ + "static/media/target.53dae7734457f4b1beb473a0d9f780c3.svg";
export { ForwardRef as ReactComponent };